import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { OfficeSideSheetButton } from 'src/components/OfficeSidesheet/OfficeSidesheetButton/OfficeSidesheetButton';
import { getParkingLocation } from 'src/store/parking/selectors';
import { sidesheetActions } from 'src/store/sidesheet/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export interface ParkingOfficeSidesheetButtonProps {
  small?: boolean;
}

export const ParkingOfficeSidesheetButton: FC<
  ParkingOfficeSidesheetButtonProps
> = ({ small }) => {
  const dispatch = useAppDispatch();
  const { town, building, loading } = useSelector(getParkingLocation);

  const open = useCallback(() => {
    dispatch(sidesheetActions.open('parkingOffice'));
  }, [dispatch]);

  return (
    <OfficeSideSheetButton
      onClick={open}
      town={town}
      building={building}
      disabled={loading}
      small={small}
    />
  );
};
